<ng-container *transloco="let t">
  <div class="my-2 flex gap-5 max-md:flex-col md:items-center">
    <p class="max-w-48 truncate">{{ fromClientName$ | async }}</p>

    <tui-icon icon="@tui.chevrons-right" />

    <pxc-client-picker
      class="flex-1"
      data-testid="client-picker"
      [clients]="movableClients$ | async"
      [(selectedClient)]="toClientCode" />
  </div>

  <div class="flex justify-between gap-2 max-md:flex-col-reverse">
    <button appearance="outline" data-testid="cancel" tuiButton type="button" (click)="cancel()">
      {{ t('Annuler') }}
    </button>
    <button data-testid="confirm" tuiButton type="button" [disabled]="!toClientCode" (click)="move()">
      {{ t('Déplacer') }}
    </button>
  </div>
</ng-container>
